import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import OfferCard from '../components/OfferCard';
import OFFERS from '../config/offers.json';
import { getOrder } from '../utils/api';
import { trackEvent } from '../utils/tracking';
import './Offers.css';

export default function Offers() {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order');
  const [gateStatus, setGateStatus] = useState(orderId ? 'checking' : 'invalid');

  useEffect(() => {
    trackEvent('Page Viewed', { page: 'offers' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!orderId) return;
    getOrder(orderId)
      .then(() => setGateStatus('valid'))
      .catch(() => setGateStatus('invalid'));
  }, [orderId]);

  if (gateStatus === 'invalid') {
    return (
      <div className="tp-offers">
        <Header />
        <div className="container tp-offers__gate">
          <p className="body-l">This page is for Travel+ customers.</p>
          <Link to="/" className="btn btn-primary">Back to Travel+</Link>
        </div>
      </div>
    );
  }

  if (gateStatus === 'checking') return null;

  return (
    <div className="tp-offers">
      <Header />
      <div className="container tp-offers__content">
        <h1 className="headline-1">Your exclusive offers</h1>
        <div className="tp-offers__grid">
          {OFFERS.map((offer, i) => (
            <OfferCard key={`${offer.partner}-${i}`} offer={offer} />
          ))}
        </div>
        <p className="body-s tp-offers__disclaimer">
          Offers are provided by third-party partners and aren't affiliated with or endorsed by Faye. Terms apply on each partner's site.
        </p>
      </div>
      <Footer />
    </div>
  );
}
